import React, { useEffect, useState } from "react";
import SplashLogo from "../assets/Splash-A-logo-1.png";
import SriGayatriImage from "../assets/Sri Gayatri.png";
import AyusanjivniImage from "../assets/ayusanjivni1.png";

const SplashScreen = () => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setStep(1), 400),   // Logo fade
      setTimeout(() => setStep(2), 1100),  // Sri Gayatri
      setTimeout(() => setStep(3), 1800),  // Ayusanjivni (NOT too late)
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-[#ebe0cf] z-[9999] overflow-hidden">

      {/* Glow Background */}
      <div className="absolute w-[500px] h-[500px] bg-[#d9c5ac] rounded-full blur-[120px] opacity-40 animate-glow"></div>

      {/* Logo */}
      <img
        src={SplashLogo}
        alt="Logo"
        className={`w-40 h-auto mb-12 transition-all duration-700 ease-out 
          ${step >= 1 ? "opacity-100 scale-100" : "opacity-0 scale-90"}
        `}
        style={{ width : '20%', height: 'auto' }}
      />

      {/* Sri Gayatri */}
      {/* <img
        src={SriGayatriImage}
        alt="Sri Gayatri"
        className={`max-w-xs md:max-w-sm transition-all duration-[1100ms] ease-out
          ${step >= 2 ? "opacity-100 blur-0 translate-y-0 scale-100" : "opacity-0 blur-2xl translate-y-4 scale-95"}
        `}
        style={{ marginLeft: "-5%" }}
      /> */}

      {/* Ayusanjivni (EXACT SAME ANIMATION) */}
      <img
        src={AyusanjivniImage}
        alt="Ayusanjivni"
        className={`max-w-md md:max-w-lg -mt-8 transition-all duration-[1100ms] ease-out
          ${step >= 3 ? "opacity-100 blur-0 translate-y-0 scale-100" : "opacity-0 blur-2xl translate-y-4 scale-95"}
        `}
        style={{ marginLeft: "4%" }}
      />
    </div>
  );
};

export default SplashScreen;
